export default "__VITE_ASSET__DT6k_0yH__"